<template>
  <div class="tab-pane" role="tabpanel" aria-labelledby="home-tab">
    <div class="row mb-3 mt-3">
      <div class="col-md-3">
        <b-button-group>
          <b-button variant="outline-danger">
            <input
              v-model="selectAll"
              type="checkbox"
              @change="selectItemAll(selectAll)"
            />
          </b-button>
          <b-button
            variant="outline-danger"
            type="button"
            :disabled="recordIds.length == 0"
            @click="multiDelete"
            v-if="$role == 'super_admin'"
          >
            <i class="fa fa-trash" />
            {{ $t("site.bulk_delete") }}
          </b-button>
        </b-button-group>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <input
            v-model="search"
            type="text"
            autofocus
            class="form-control"
            :placeholder="$t(`site.search`)"
            @input="(val) => searchChange(val)"
          />
        </div>
      </div>
      <div class="col-3">
        <div class="float-md-right pt-1">
          <span class="text-muted text-small mr-1 mb-2">
            {{ from }}:{{ to }}
          </span>

          <b-dropdown
            id="ddown2"
            right
            :text="`${perPage}`"
            variant="outline-warning"
            size="xs"
          >
            <b-dropdown-item
              v-for="(size, index) in [5, 10, 20, 50, 100]"
              :key="index"
              @click="changePageSize(size)"
            >
              {{ size }}
            </b-dropdown-item>
          </b-dropdown>
          <span class="text-muted mr-1 mb-2"> of {{ total }}</span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 overflow-auto">
        <b-table :stacked="($mobile==1)" 
          ref="table"
          class="vuetable"
          sort-by="id"
          :current-page="currentPage"
          :fields="bootstrapTable.fields"
          :items="dataProvider"
        >
          <template #cell(checkbox)="data">
            <label class="kt-checkbox kt-checkbox--single kt-checkbox--solid">
              <input
                v-model="recordIds"
                type="checkbox"
                :value="data.item.id"
                @change="selectItem(data)"
              />
              <span />
            </label>
          </template>
          <template #cell(reason)="data">
            <div v-html="data.item.reason"></div>
          </template>
          <template #cell(edit)="data">
            <b-button
              @click="getApologies(data.item)"
              variant="outline-primary"
               
            >
              {{ $t("site.read") }}
            </b-button> </template>
        </b-table>
        <b-spinner v-if="load" type="grow" label="Loading..." class="loading" />

        <hr />
        <b-pagination
          v-model="currentPage"
          align="right"
          class="dataTables_paginate paging_simple_numbers pagination-warning"
          :total-rows="totalRows"
          :per-page="perPage"
        >
          <template v-slot:next-text>
            <i class="fas fa-angle-left" />
          </template>
          <template v-slot:prev-text>
            <i class="fas fa-angle-right" />
          </template>
          <template v-slot:first-text>
            <i class="fas fa-step-forward" />
          </template>
          <template v-slot:last-text>
            <i class="fas fa-step-backward" />
          </template>
        </b-pagination>

        <!-- end of table -->
      </div>
      <!-- end of col -->
    </div>
    <!-- end of row -->
    <b-modal
      ref="modal-primary"
      ok-only
      ok-title="ok"
      size="lg"
      modal-class="modal-primary"
      centered
    >
      <b-card-text>
        <b-spinner
          v-if="loadStatus"
          type="grow"
          label="Loading..."
          class="loading"
        />
        <b-row>
          <b-col lg="12">
            <app-timeline>
              <app-timeline-item
                v-for="status in apologyStatus"
                :key="status.id"
                :title="status.status"
                :subtitle="status.reason"
                :time="status.created_at.split('T')[0]"
              />
            </app-timeline>
          </b-col>
        </b-row>
        <hr />

        <b-row>
          <b-col lg="12">
            <validation-observer
              ref="registerForm"
              #default="{ invalid }"
              v-if="apologySelsct.accept == 0"
            >
              <b-form>
                <b-row>
                  <b-col cols="12">
                    <b-form-group class="mb-2">
                      <div class="demo-inline-spacing">
                        <b-form-radio
                          v-model="newData.status"
                          name="some-radio9"
                          value="approval"
                          class="custom-control-success"
                        >
                          قبول
                        </b-form-radio>

                        <b-form-radio
                          v-model="newData.status"
                          name="some-radio9"
                          value="refusal"
                          class="custom-control-danger"
                        >
                          رفض
                        </b-form-radio>
                      </div>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12">
                    <validation-provider
                      #default="{ errors }"
                      :name="$t('apology.reason')"
                      vid="reason"
                      rules="required"
                    >
                      <b-form-group class="mb-2">
                        <ckeditor
                          :config="{ contentsLangDirection : 'rtl',versionCheck : false}" 
                          v-model="newData.reason"
                          :placeholder="$t('apology.reason')"
                          :state="errors.length > 0 ? false : null"
                        />
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="12">
                    <b-button
                      block
                      :disabled="invalid"
                      variant="primary"
                      @click="submitStatus()"
                    >
                      <i class="fa fa-plus" /> {{ $t("site.save") }}
                    </b-button>
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>
  </div>
</template>

<script>
import controller from "@/Controllers/ApologyController";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import ApologyStatusController from "@/Controllers/ApologyStatusController";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";
import Auth from "@/Apis/Auth";
export default {
  name: "ApologyDataTable",
  props: ["items", "editItem"],
  components: {
    required,
    ValidationProvider,
    ValidationObserver,
    AppTimeline,
    AppTimelineItem,
  },
  data() {
    return {
      bootstrapTable: {
        selected: [],
        selectMode: "multi",
        fields: [
          { key: "checkbox", label: "", sortable: false },
          {
            key: "reason",
            label: this.$i18n.t("apology.reason"),
            sortable: true,
          },
          {
            key: "user.full_name",
            label: this.$i18n.t("users.user"),
            sortable: true,
          },
          {
            key: "online_session.title",
            label: this.$i18n.t("online_session.online_session"),
            sortable: true,
          },

          { key: "edit", label: this.$i18n.t("site.action"), sortable: false },
        ],
      },
      data: {},
      selectAll: false,
      currentPage: 1,
      select: [],
      page: 1,
      perPage: 5,
      search: "",
      from: 0,
      total: 0,
      totalRows: 0,
      to: 0,
      lastPage: 0,
      load: false,
      newData:{},
      apiParams: {},
      params: {},
      recordIds: [],
      apologyUser: 0,
      apologies: [],
      apologyStatus: [],
      loadStatus: false,
      apologySelsct: {},
    };
  },
  methods: {
    async getApologies(item) {
      this.loadStatus = true;
      this.apologyStatus = [];
      this.$refs["modal-primary"].show();
       
      this.apologySelsct = item;
      this.apologyStatus = await new ApologyStatusController().GetAll({
        filter: "apology_id|" + item.id,
      });
      this.loadStatus = false;
    },
    
 
   
    async submitStatus() {
      this.newData.user_id = Auth.USER.id;
      this.newData.apology_user_id = this.apologySelsct.user_id;
      this.newData.apology_id = this.apologySelsct.id;
      this.newData.online_session_id = this.apologySelsct.apologytable_id;

      const ap = await new ApologyStatusController().From(this.newData);
      this.$refs["modal-primary"].hide();
      this.$refs.table.refresh();
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    async dataProvider(ctx) {
      this.load = true;
      this.params = ctx;
      const data = await new controller().GetAll(this.apiParamsConverter());
      this.currentPage = data.current_page;
      this.perPage = data.per_page;
      this.totalRows = data.total;
      this.from = data.from;
      this.to = data.to;
      this.total = data.total;
      this.data = data.data;
      this.load = false;
      return data.data;
    },
    apiParamsConverter() {
      const apiParams = { per_page: this.perPage };
      if (this.params.currentPage >= 1) {
        apiParams.page = this.params.currentPage;
      }
      if (this.params.sortBy && this.params.sortBy.length > 0) {
        apiParams.sort = `${this.params.sortBy}|${
          this.params.sortDesc ? "desc" : "asc"
        }`;
      }
      if (this.params.filter && this.params.filter.length > 0) {
        // Optional
      }
      if (this.search !== "") {
        apiParams.search = this.search;
      }
      apiParams.with = ["user", "onlineSession"];
      apiParams.filter = "accept|0";
      return apiParams;
    },
    changePageSize(perPage) {
      this.page = 1;
      this.perPage = perPage;
      this.dataProvider(this.params);
      this.$refs.table.refresh();
    },
    searchChange() {
      if (this.search.length == 0) {
        this.dataProvider(this.params);
        this.$refs.table.refresh();
      }
      if (this.search.length < 2) return;
      this.page = 1;
      this.dataProvider(this.params);
      this.$refs.table.refresh();
    },
    selectItemAll(select) {
      this.recordIds = [];
      if (select) {
        console.log(this.data);
        this.data.forEach((element) => {
          this.recordIds.push(element.id);
        });
      }
    },
    deleteItem(data) {
      new controller().Delete(data.item.id, [], this.$refs.table);
    },
    multiDelete() {
      new controller().Delete(0, this.recordIds, this.$refs.table);
    },
  },
};
</script>
